module.exports = ".auth-brand{width:calc(100% - 7rem)}\n"